import type { GetResult, ListResult } from "@prolarus/shared";
import { tryGet, tryList, toQueryString } from "./_shared";

export interface UserPermission {
  permission_id: string;
  permission_code: string;
  permission_name: string;
  category: string;
  grant_source: "DIRECT" | "GROUP";
  group_id: string | null;
  group_name: string | null;
}

// _companyId is preserved in the signature for call-site compatibility with the
// old client-side service. The route derives company_id from the JWT and
// ignores any client-supplied value (deliberate — vw_profile_permissions is a
// SECURITY DEFINER view; clamping to JWT prevents cross-tenant probing).
export const permissionService = {
  hasPermission(
    profileId: string,
    _companyId: string,
    permissionCode: string,
  ): Promise<GetResult<boolean>> {
    return tryGet<boolean>(
      `/api/permissions/check${toQueryString({ profile_id: profileId, code: permissionCode })}`,
    );
  },

  hasAnyPermission(
    profileId: string,
    _companyId: string,
    permissionCodes: string[],
  ): Promise<GetResult<boolean>> {
    return tryGet<boolean>(
      `/api/permissions/check-any${toQueryString({ profile_id: profileId, codes: permissionCodes.join(",") })}`,
    );
  },

  getUserPermissions(
    profileId: string,
    _companyId: string,
  ): Promise<ListResult<UserPermission>> {
    return tryList<UserPermission>(
      `/api/permissions${toQueryString({ profile_id: profileId })}`,
    );
  },
};
